import httpClient from '../httpClient';
import publicHttpClient from 'api/publicHttpClient';

function submitBuyerSubscription(values: any) {
  return httpClient.post('buyer-subscriptions/submit', values);
}

function registerAndSubmitBuyerSubscription(values: any) {
  return publicHttpClient.post('buyer-subscriptions/submit-and-signup', values);
}

export default {
  submitBuyerSubscription,
  registerAndSubmitBuyerSubscription,
};
